import { formatPhoneNumber } from "@/shared/utils/phone-utils";
import { Alert, AlertDescription, AlertTitle } from "@/src/components/shadcn/ui/alert";
import { normalizePhoneNumber } from "@/src/models/common-schema";

export function SchedulingErrorAlert({
  clinicPhoneNumber,
  isIneligible = false,
}: {
  clinicPhoneNumber?: string | null;
  isIneligible?: boolean;
}) {
  const phoneNumber = normalizePhoneNumber(clinicPhoneNumber);

  return (
    <Alert variant="destructive">
      <AlertTitle>{isIneligible ? "Unable to schedule online" : "We couldn’t complete your request"}</AlertTitle>
      <AlertDescription>
        {isIneligible
          ? "You are currently not eligible to schedule online, please call "
          : "We’re unable to complete your appointment request online. Please call "}
        {phoneNumber ? (
          <a href={`tel:${formatPhoneNumber(phoneNumber)}`} className="font-medium underline underline-offset-4">
            {phoneNumber}
          </a>
        ) : (
          "the clinic"
        )}{" "}
        {isIneligible ? "so we can assist you with your request." : "for help scheduling your visit."}
      </AlertDescription>
    </Alert>
  );
}
